<template>
  <div class="share">
    <share-container></share-container>
  </div>
</template>
<script>
import ShareContainer from '@/components/share/Container.vue'
export default {
  name: 'share',
  components: {
    ShareContainer
  }
}
</script>
<style lang="stylus">
.share
  height 100%
</style>
